/* eslint-disable no-nested-ternary */
/* eslint-disable no-param-reassign */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable import/no-named-as-default-member */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/no-unresolved */
/* eslint-disable no-useless-return */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import {
    Link, Navigate, useNavigate, useParams,
} from 'react-router-dom';
import S3 from 'react-aws-s3';
import { uploadFile } from 'react-s3';
import DirectOrderSummary from '../DirectOrderSummary';
import { GenerateDateFormat } from '../../../../redux/helper/DateConverter';
import { Uploadconfig } from '../../../../redux/helper/upload-config';
import { distributorService } from '../../../../service/distributor.service';
import { CDN } from '../../../../constants';
import OrderConfirmModal from './OrderConfirmModal';
import OrderPlacedModal from './OrderPlacedModal';

const toggleState = {
    request_date: false,
    po_date: false,
    offer_type: false,
    type: false,
};

function OrderDetailsForm() {
    const { orderId, distributorId } = useParams();
    const location = useNavigate();
    const [toggle, settoggle] = useState(toggleState);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [submitSelected, setsubmitSelected] = useState(false);
    const [loading, setloading] = useState(false);
    const [OrderDetails, setOrderDetails] = useState({});
    const [UserRole, setUserRole] = useState('');
    const [itemKey, setitemKey] = useState('');
    const [createPopup, setCreatePopup] = useState(false);
    const [successPopup, setSuccessPopup] = useState(false);
    const [distributorDetails, setdistributorDetails] = useState({});
    const [FOBFeight, setFOBFeight] = useState({});
    const [ase, setASE] = useState(false);
    const [ccc, setCcc] = useState(false);
    const [attachmentError, setAttachmentError] = useState(false);
    const [orderDetailsFormData, setOrderDetailsFormData] = useState({
        request_date: '',
        assigned_asm: '',
        po_number: '',
        po_date: '',
        attachedFile: [],
        freight_terms: '',
        delivery_terms: '',
        order_comment: '',
        workflow_comment: '',
        icd_number: '',
    });
    const [render, setRender] = useState(false);

    const ReactS3Client = new S3(Uploadconfig);
    useEffect(() => {
        const data = JSON.parse(localStorage.getItem('user')).profile;
        if (data.roles === 'customer_care_centre_head') {
            setCcc(true);
        }
    }, []);
    const [errorState, setErrorState] = useState({
        request_date: '',
        assigned_asm: '',
        po_number: '',
        po_date: '',
        icd_number: '',
        freight_terms: '',
        delivery_terms: '',
    });

    const handlePrefetchDetails = (distributor) => {
        const data = JSON.parse(localStorage.getItem('user')).profile;
        if (data.roles === 'area_sales_engineer') {
            setASE(true);
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                assigned_asm: data.email,
            }));
        }
        if (data.roles === 'customer_care_centre_head') {
            distributor.SUPPORTS.push({
                EMAIL: data.email,
                EMPLOYEE_CODE: data.employee_code,
                LAST_NAME: data.first_name,
                ROLES: 'area_sales_engineer',
                FIRST_NAME: data.last_name,
                PRODUCT_CATEGORIES: [
                    'CONSUMABLES',
                    'EQUIPMENT',
                    'OTHERS',
                ],
            });
            setdistributorDetails(distributor);
            setASE(true);
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                assigned_asm: data.email,
            }));
        }
    };

    useEffect(() => {
        setRender(true);
    }, [render]);

    // useEffect(() => {
    //     handlePrefetchDetails();
    // }, []);

    const InputChange = (e, index) => {
        e.preventDefault();
        const { id, value } = e.target;
        if (value.trim() === '') {
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const handleSelect = (id, value) => {
        if (value.trim() === '') {
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                [id]: '',
            }));
        } else {
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                [id]: value,
            }));
        }
    };

    const handleUploadedFiles = (val, key) => {
        setAttachmentError(false);
        setRender(true);
        const data = { ...orderDetailsFormData };
        data.po_document = [val];
        setOrderDetailsFormData(data);
    };

    const handleDropdownStatus = () => {
        settoggle(toggleState);
    };

    const handleToggle = (key) => {
        handleDropdownStatus();
        const val = key === 'request_date' ? 'po_date' : 'request_date';
        settoggle((prevState) => ({
            ...prevState,
            [key]: !toggle[key],
            [val]: false,
        }));
    };

    const handleDate = (val, key) => {
        if (key === 'request_date') {
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                po_date: '',
            }));
        }
        setOrderDetailsFormData((prevState) => ({
            ...prevState,
            [key]: val,
        }));
        settoggle(toggleState);
    };

    const handleUploadDoc = (e, key) => {
        const { files } = e.target;
        // make sure that it's not null or undefined
        // setspinner(key);

        if (files.length === 0) {
            return;
        }
        // make sure that it's not null or undefined
        // setspinner(key);

        ReactS3Client.uploadFile(files[0], files[0].name)
            .then((data) => {
                setRender(true);
                handleUploadedFiles(data.key, key);
            })
            .catch((err) =>
                // handleUploadedFiles('eub/ed0ef5a-f27-a510-4d6-c4ae8c42c77c/sample(1).pdf',key);
                // setspinner('');
                err);

        // need to set something
    };

    const validate = () => {
        let isvalid = true;
        setAttachmentError(false);
        const isDomesticOrder = OrderDetails?.order_type === 'Domestic';

        Object.keys(orderDetailsFormData).forEach((value) => {
            switch (value) {
            case 'request_date':
            case 'po_number':
            case 'po_date':
                if (orderDetailsFormData[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: `${value} is required`,
                    }));
                    isvalid = false;
                }
                break;
            case 'assigned_asm':
                if (!ase && orderDetailsFormData[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: 'ASE/ASM is required',
                    }));
                    isvalid = false;
                }
                break;
            case 'icd_number':
                if (ccc && orderDetailsFormData[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: 'ICD Number is required',
                    }));
                    isvalid = false;
                }
                break;
            case 'delivery_terms':
                // delivery_terms field stores Freight Terms selection (due to original ID swap)
                if (isDomesticOrder && orderDetailsFormData[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: 'Freight Terms is required',
                    }));
                    isvalid = false;
                } else {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: '',
                    }));
                }
                break;
            case 'freight_terms':
                // freight_terms field stores Delivery Terms selection (due to original ID swap)
                if (isDomesticOrder && orderDetailsFormData[value] === '') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: 'Delivery Terms is required',
                    }));
                    isvalid = false;
                } else {
                    setErrorState((prevState) => ({
                        ...prevState,
                        [value]: '',
                    }));
                }
                break;
            default: break;
            }
        });
        if (orderDetailsFormData.po_document === undefined || (orderDetailsFormData?.po_document?.length === 0)) { isvalid = false; setAttachmentError(true); }

        return isvalid;
    };

    const handleCreatePopup = () => {
        setErrorState((prev) => ({
            ...prev,
            icd_number: '',
            freight_terms: '',
            delivery_terms: '',
        }));
        setsubmitSelected(true);
        if (validate()) {
            setCreatePopup(!createPopup);
        }
    };

    const handlePlaceOrder = async (e, accept) => {
        if (validate()) {
            setCreatePopup(true);
            const { email } = JSON.parse(localStorage.getItem('user')).profile;
            const payload = {
                request_date: moment.unix(orderDetailsFormData.request_date).format('X'),
                ASEs: distributorDetails?.SUPPORTS?.filter((val) => val.EMAIL === orderDetailsFormData.assigned_asm),
                po_number: orderDetailsFormData.po_number,
                po_date: moment.unix(orderDetailsFormData.po_date).format('X'),
                po_document: orderDetailsFormData.po_document,
                freight_terms: orderDetailsFormData.freight_terms,
                delivery_terms: orderDetailsFormData.delivery_terms,
                instruction: orderDetailsFormData.order_comment,
                workflow_comment: orderDetailsFormData.workflow_comment,
                initiator_role: UserRole,
                initiator: email,
                status: accept === true ? 1 : -1,
                ...(ccc && { icd_number: orderDetailsFormData.icd_number.trim() }),
            };
            setCreatePopup(!createPopup);
            const res = await distributorService.OrderStatusUpdate(payload, OrderDetails.distributor_id, OrderDetails.order_number);
            if (!res.error && res.data.success_status) {
                setCreatePopup(false);
                setSuccessPopup(true);
            } else {
                setCreatePopup(false);
                if (res?.message === 'ICD Number already exists.') {
                    setErrorState((prevState) => ({
                        ...prevState,
                        icd_number: res?.message,
                    }));
                }
                return;
            }
        } else {
            setCreatePopup(false);
        }
        setsubmitSelected(true);
        e.preventDefault();
        setErrorState({
            request_date: '',
            po_number: '',
            po_date: '',
            icd_number: '',
            freight_terms: '',
            delivery_terms: '',
        });
    };

    const getDistributor = (id) => {
        distributorService.getDistributorDetail(id).then((res) => {
            if (!res.error && res.data.success_status) {
                setdistributorDetails(res?.data?.data);
                handlePrefetchDetails(res?.data?.data);
            }
        });
    };

    const getFreightFOB = (id) => {
        distributorService.GetFOBFeight().then((res) => {
            if (!res.error && res.data.success_status) {
                setFOBFeight(res?.data?.data);
            }
        });
    };

    const handleFetchOrder = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                setOrderDetails(details.data.data);
                getDistributor(details?.data?.data?.distributor_id);
                getFreightFOB();
                setitemKey(Object.keys(details.data.data.items)[0]);
                const current = JSON.parse(localStorage.getItem('user')).profile.roles;
                setUserRole(current);
                setloading(false);
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [],
    );

    const handleDelete = () => {
        if (orderDetailsFormData.po_document !== undefined && (orderDetailsFormData.po_document).length > 0) {
            const arr = orderDetailsFormData.po_document;
            arr.shift();
            setOrderDetailsFormData((prevState) => ({
                ...prevState,
                attachedFile: arr,
            }));
        }
    };

    useEffect(() => {
        handleFetchOrder();
    }, []);
    return (
        <>

            <div className="flex items-center pl-3 pt-5">
                <Link to={`/manage-orders/direct-order/${distributorId}/${orderId}/edit/cart`}>
                    <img src="/images/Icon-feather-arrow-left.svg" alt="icon" className="pr-4 cursor-pointer" />
                </Link>
                <h5 className="text-xs10 font-semibold text-[#090406]">Order Details</h5>
            </div>
            <div className="w-full flex px-5 overflow-x-hidden">
                <div className="w-[70%] px-3 pb-4">
                    <div className="sticky top-0 border-b border-[#EBEBEB] bg-[#fff] z-[9]">
                        <img style={{ borderRadius: '50%', objectFit: 'cover' }} src={OrderDetails?.distributor_info?.profile_image_url && OrderDetails?.distributor_info?.profile_image_url !== '' ? (`${CDN}/${OrderDetails?.distributor_info?.profile_image_url}`) : '/images/pp.svg'} className="cursor-pointer w-[70px] h-[70px]" alt="icon" />
                        <p className="absolute text-sm28 font-semibold top-[18px] left-[100px]">
                            {' '}
                            {OrderDetails?.distributor_info?.PARTY_NAME}
                        </p>
                        <p className="absolute text-sm29 text-[#555259] font-normal top-[50px] left-[100px]">
                            {' '}
                            {distributorId}
                            {' '}
                        </p>
                    </div>
                    <div className="flex mt-5 -mx-4">
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <label for="offercode1" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    Request Date
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                                <img
                                    src="/images/Iconawesome-calendar-alt.svg"
                                    alt="icon"
                                    className="absolute top-4 right-5 cursor-pointer"
                                    onClick={() => handleToggle('request_date')}
                                />
                                <input
                                    datepicker
                                    datepicker-autohide
                                    type="text"
                                    className="cursor-pointer h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 placeholder:font-normal placeholder:text-base placeholder:text-[#A5A5A5]"
                                    placeholder="Select Date"
                                    onClick={() => {
                                        handleToggle('request_date');
                                        setsubmitSelected(false);
                                    }}
                                    value={orderDetailsFormData.request_date !== '' ? GenerateDateFormat(orderDetailsFormData.request_date) : ''}
                                />
                            </div>
                            <div>
                                {toggle.request_date && (
                                    <Calendar
                                        value={orderDetailsFormData.request_date}
                                        onChange={(val) => handleDate(val, 'request_date')}
                                        minDate={moment().toDate()}

                                    />
                                )}
                            </div>
                            {submitSelected && orderDetailsFormData.request_date === '' && <span className="text-s font-light text-[#ED1C24]">Request Date is required</span>}

                        </div>
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <select
                                    id="assigned_asm"
                                    className={`h-12 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] bg-[#FFFFFF] font-normal text-base ${orderDetailsFormData.assigned_asm === '' ? 'text-[#A5A5A5]' : 'text-[#090406]'} px-3.5`}
                                    autocomplete="off"
                                    disabled={ase}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                    }}
                                >
                                    <option value="">Select ASE/ASM</option>
                                    {Object.keys(distributorDetails).length > 0 && distributorDetails?.SUPPORTS?.filter((val) => (val.roles === 'area_sales_engineer' || val.ROLES === 'area_sales_engineer' || val.roles === 'area_sales_manager' || val.ROLES === 'area_sales_manager') && val.PRODUCT_CATEGORIES.includes(OrderDetails.initial_category === 'Equipments' ? 'EQUIPMENT' : OrderDetails.initial_category === 'MnR' ? 'MnR' : OrderDetails.initial_category.toUpperCase())).map((role) => (
                                        <option
                                            value={role.EMAIL}
                                            selected={orderDetailsFormData.assigned_asm === role.EMAIL}
                                            onClick={() => handleSelect('assigned_asm', role)}
                                        >
                                            {role.first_name || role.FIRST_NAME}
                                            {' '}
                                            {role.last_name || role.LAST_NAME}
                                            {' '}
                                            <span className="text-lg  text-[#A1A1A1]">{role?.EMPLOYEE_CODE}</span>
                                            {' '}
                                            <span className="text-lg  text-[#A1A1A1]">
                                                {role?.PRODUCT_CATEGORIES?.length > 0 && <>{role?.PRODUCT_CATEGORIES?.toLocaleString()}</>}
                                                {' '}
                                            </span>

                                        </option>
                                    ))}

                                </select>
                                <label for="assigned_asm" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    ASE/ASM
                                    {!ase && <span className="text-[#ED1C24]">*</span>}
                                </label>
                            </div>
                            {!ase && submitSelected && orderDetailsFormData.assigned_asm === '' && <span className="text-s font-light text-[#ED1C24]">ASE/ASM is required</span>}
                        </div>
                    </div>
                    <div className="flex mt-8 -mx-4">
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <input
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                    }}
                                    type="text"
                                    id="po_number"
                                    maxLength="50"
                                    className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                    autocomplete="off"
                                    value={orderDetailsFormData.po_number}
                                />
                                <label for="po_number" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    PO Number
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                            </div>
                            {submitSelected && orderDetailsFormData.po_number === '' && <span className="text-s font-light text-[#ED1C24]">PO Number is required</span>}
                        </div>
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <label for="offercode1" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    PO Date
                                    <span className="text-[#ED1C24]">*</span>
                                </label>
                                <img
                                    src="/images/Iconawesome-calendar-alt.svg"
                                    alt="icon"
                                    className="absolute top-4 right-5 cursor-pointer"
                                    onClick={() => handleToggle('po_date')}
                                />
                                <input
                                    datepicker
                                    datepicker-autohide
                                    type="text"
                                    className="cursor-pointer h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 placeholder:font-normal placeholder:text-base placeholder:text-[#A5A5A5]"
                                    placeholder="Select Date"
                                    onClick={() => {
                                        handleToggle('po_date');
                                        setsubmitSelected(false);
                                    }}
                                    value={orderDetailsFormData.po_date !== '' ? GenerateDateFormat(orderDetailsFormData.po_date) : ''}

                                />
                            </div>
                            <div>
                                {toggle.po_date && (
                                    <Calendar
                                        value={orderDetailsFormData.po_date}
                                        onChange={(val) => handleDate(val, 'po_date')}
                                        maxDate={moment().toDate()}
                                    />
                                )}
                            </div>
                            {submitSelected && orderDetailsFormData.po_date === '' && <span className="text-s font-light text-[#ED1C24]">PO Date is required</span>}
                        </div>
                    </div>
                    <div class="relative mt-2.5 mb-1 bg-[#555259] rounded-lg px-[14px] py-3 h-8 pb-7 w-[124px] cursor-pointer">
                        <input type="file" id="file" onChange={(e) => handleUploadDoc(e, 'attach_po')} class="opacity-0 absolute top-0 left-0 cursor-pointer w-[95px]" />
                        <label for="file" class="font-normal text-xs13 text-white absolute left-0 top-2 px-[14px] cursor-pointer">+ Attach a file*</label>
                    </div>
                    {attachmentError && <span className="text-s font-light text-[#ED1C24]">PO Document is required</span>}
                    {orderDetailsFormData.po_document !== undefined && (orderDetailsFormData.po_document).length > 0 && (orderDetailsFormData.po_document).map((ele) => (
                        <div className="flex align-items">
                            <div className="pr-2">{ele}</div>
                            <div className="pt-[6px]">
                                {' '}
                                <img
                                    src="/images/circle-close.svg"
                                    alt="icon"
                                    className="pr-4 cursor-pointer"
                                    onClick={() => handleDelete()}
                                />
                            </div>

                        </div>
                    ))}
                    <div className="mt-7 flex -mx-4">
                        <div className="w-1/2 px-4">
                            <div className="dropdown relative">
                                <select
                                    id="delivery_terms"
                                    value={orderDetailsFormData.delivery_terms || ''}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                        setErrorState((prevState) => ({
                                            ...prevState,
                                            delivery_terms: '',
                                        }));
                                    }}
                                    className={`h-12 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] bg-[#FFFFFF] font-normal text-base ${orderDetailsFormData.delivery_terms === '' ? 'text-[#A5A5A5]' : 'text-[#090406]'} px-3.5`}
                                    autocomplete="off"
                                >
                                    <option value="">Select Freight Terms </option>
                                    {Object.keys(FOBFeight).length > 0 && FOBFeight.fob.map((fob) => (
                                        <option value={fob.LOOKUP_CODE}>
                                            {fob.MEANING}
                                        </option>
                                    ))}
                                </select>
                                <label for="delivery_terms" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    Freight Terms
                                    {OrderDetails?.order_type === 'Domestic' && <span className="text-[#ED1C24]">*</span>}
                                </label>
                            </div>
                            {submitSelected && errorState.delivery_terms && <span className="text-s font-light text-[#ED1C24]">{errorState.delivery_terms}</span>}
                        </div>
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <select
                                    id="freight_terms"
                                    value={orderDetailsFormData.freight_terms || ''}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                        setErrorState((prevState) => ({
                                            ...prevState,
                                            freight_terms: '',
                                        }));
                                    }}
                                    className={`h-12 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] bg-[#FFFFFF] font-normal text-base ${orderDetailsFormData.freight_terms === '' ? 'text-[#A5A5A5]' : 'text-[#090406]'} px-3.5`}
                                    autocomplete="off"
                                >
                                    <option value="">
                                        Select Delivery Terms
                                    </option>
                                    {Object.keys(FOBFeight).length > 0 && FOBFeight.freight.map((freight) => (
                                        <option value={freight.LOOKUP_CODE}>
                                            {freight.MEANING}
                                        </option>
                                    ))}

                                </select>
                                <label for="freight_terms" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                    Delivery Terms
                                    {OrderDetails?.order_type === 'Domestic' && <span className="text-[#ED1C24]">*</span>}
                                </label>
                            </div>
                            {submitSelected && errorState.freight_terms && <span className="text-s font-light text-[#ED1C24]">{errorState.freight_terms}</span>}
                        </div>
                    </div>
                    <div className="flex mt-8 -mx-4">
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <textarea
                                    type="text"
                                    id="order_comment"
                                    className="h-[123px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 py-2.5 placeholder:font-normal placeholder:text-base placeholder:text-[#A5A5A5] resize-none"
                                    placeholder="Enter Order Comment"
                                    autocomplete="off"
                                    value={orderDetailsFormData.order_comment}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                    }}
                                />
                                <label for="order_comment" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Order Comment</label>
                            </div>
                        </div>
                        <div className="w-1/2 px-4">
                            <div className="relative">
                                <textarea
                                    type="text"
                                    id="workflow_comment"
                                    className="h-[123px] w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5 py-2.5 placeholder:font-normal placeholder:text-base placeholder:text-[#A5A5A5] resize-none"
                                    placeholder="Enter Workflow Comment"
                                    autocomplete="off"
                                    value={orderDetailsFormData.workflow_comment}
                                    onChange={(e) => {
                                        InputChange(e);
                                        setsubmitSelected(false);
                                    }}
                                />
                                <label for="workflow_comment" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">Workflow Comment</label>
                            </div>
                        </div>
                    </div>
                    <div className="flex mt-5 -mx-4">
                        <div className="w-1/2 px-4">
                            <div className="relative bg-[#F5F5FA]">
                                <input
                                    type="text"
                                    id="consumables_plant"
                                    className="h-12 w-full rounded-lg outline-0 border bg-[#F5F5FA] border-[#B1B4B7] text-lg font-normal text-[#090406] px-3.5"
                                    autoComplete="off"
                                    value={!loading && itemKey !== '' && itemKey !== '' && OrderDetails?.items[itemKey][0]['3pl'].DESCRIPTION}
                                    disabled
                                />
                                <label
                                    htmlFor="consumables_plant"
                                    className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]"
                                >
                                    Plant
                                </label>
                            </div>
                        </div>
                        {ccc && (
                            <div className="w-1/2 px-4">
                                <div className="relative">
                                    <input
                                        onChange={(e) => {
                                            if (orderDetailsFormData?.icd_number.length <= 80) {
                                                InputChange(e);
                                                setsubmitSelected(false);
                                            }
                                        }}
                                        type="text"
                                        id="icd_number"
                                        maxLength="80"
                                        className="h-12 w-full rounded-lg outline-0 border border-[#B1B4B7] bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3.5"
                                        autocomplete="off"
                                        value={orderDetailsFormData.icd_number}
                                    />
                                    <label for="po_number" className="text-xs2 font-semibold text-[#808285] absolute -top-2 left-3.5 px-1 bg-[#FFFFFF]">
                                        ICD Number
                                        <span className="text-[#ED1C24]">*</span>
                                    </label>
                                </div>

                                {submitSelected && ccc && errorState.icd_number && <span className="text-s font-light text-[#ED1C24]">{errorState?.icd_number}</span>}
                            </div>
                        )}
                    </div>
                    <div className="mt-5">
                        <div
                            className="sm:py-2 py-1 mt-2 sm:px-7 px-2.5 bg-[#F5F5FA] rounded-lg border border-[#AAA6AF] flex justify-between items-center lg:flex-nowrap flex-wrap"
                        >
                            <div className="flex">
                                <div className="w-1/2 border-r border-[#AAA6AF]">
                                    <p className="font-semibold text-[#808285] text-xs13">Billing Address</p>
                                    <p className="font-normal text-base text-[#15090E] w-[80%]">
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS.ADDRESS1}
                                        ,
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS.ADDRESS2}
                                        ,
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS.ADDRESS3}
                                        ,
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS?.STATE}`}
                                        -
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS?.POSTAL_CODE}`}
                                        ,
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS?.STATE}`}
                                        ,
                                        Location :
                                        {' '}
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS?.LOCATION}`}
                                        ,
                                        GSTIN :
                                        {' '}
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].BILLING_ADDRESS?.ATTRIBUTE2}`}
                                    </p>
                                </div>
                                <div className="w-1/2 pl-8">
                                    <p className="font-semibold text-[#808285] text-xs13">Shipping Address</p>
                                    <p className="font-normal text-base text-[#15090E] w-[80%]">
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS.ADDRESS1}
                                        ,
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS.ADDRESS2}
                                        ,
                                        {!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS.ADDRESS3}
                                        ,
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS?.CITY}`}
                                        -
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS?.POSTAL_CODE}`}
                                        ,
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS?.STATE}`}
                                        ,
                                        Location :
                                        {' '}
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS?.LOCATION}`}
                                        ,
                                        GSTIN :
                                        {' '}
                                        {`${!loading && itemKey !== '' && OrderDetails?.items[itemKey][0].SHIPPING_ADDRESS?.ATTRIBUTE2}`}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DirectOrderSummary OrderDetails={OrderDetails} type="placeOrder" handleCreatePopup={handleCreatePopup} />
            </div>
            {createPopup ? <OrderConfirmModal handlePlaceOrder={handlePlaceOrder} createPopup={createPopup} setCreatePopup={setCreatePopup} /> : null}
            {successPopup ? <OrderPlacedModal OrderDetails={OrderDetails} /> : null}
        </>

    );
}

export default OrderDetailsForm;
